import React, { Component } from 'react';
import { connect } from 'react-redux';

class Brand extends Component {
  render() {
    const { locale } = this.props;
    const url =
      locale === 'en'
        ? 'https://web.fiintrade.vn/en/'
        : 'https://web.fiintrade.vn/';
    return (
      <div className="brand inline">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img src="/images/fiintrade-logo.png" alt="logo" />
        </a>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(Brand);
